import React from "react";

export default function JobDetailModal({ isOpen, onClose, loading, jobsData }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="rounded-lg shadow-lg p-6 h-full w-full overflow-auto max-h-screen relative">
        <div className="w-full flex items-center mb-6">
          <button
            onClick={onClose}
            style={{ lineHeight: "30px" }}
            className="mx-auto h-[30px] text-white bg-yellow-500 px-5 rounded"
            aria-label="Close modal"
          >
            <span className="text-xl">&times;</span>
          </button>
        </div>
        <div className="font-sans">
          {!loading ? (
            <>
              <section className="bg-gray-500 text-white text-center py-5 px-4">
                <div className="container mx-auto">
                  <h1 className="text-3xl font-bold mb-4">
                    {jobsData?.job_title}
                  </h1>
                  <p className="text-lg mb-2">
                    Department: {jobsData?.inferred_department_name}
                  </p>
                  <p className="text-lg mb-2">
                    Company: {jobsData?.company_name}
                  </p>
                  <p className="text-sm mb-2">Posted on: 10/10/2025</p>
                  <div className="mt-8 flex justify-center space-x-4">
                    <button className="bg-white text-blue-500 font-semibold px-6 py-3 rounded-lg hover:bg-gray-100">
                      VIEW COMPANY
                    </button>
                    <button className="bg-white text-blue-500 font-semibold px-6 py-3 rounded-lg hover:bg-gray-100">
                      APPLY FOR THIS JOB
                    </button>
                  </div>
                </div>
              </section>
              <section className="bg-gray-100 py-16 px-4">
                <div className="container mx-auto grid lg:grid-cols-1 gap-10 items-start">
                  <div className="bg-white p-6 rounded-lg shadow-lg">
                    <h2 className="text-xl font-bold mb-6">About this role</h2>
                    <div className="flex items-start">
                      <div>
                        <h3 className="text-xl text-orange-600 font-bold">
                          {jobsData?.inferred_job_title} ({jobsData?.job_type})
                        </h3>
                        <p className="text-sm text-gray-600 mb-2 font-semibold">
                          {jobsData?.company_name}
                        </p>
                        <p className="text-sm text-gray-600">
                          <b>Location:</b> {jobsData?.city},{" "}
                          {jobsData?.inferred_country}
                        </p>
                        <p className="text-sm text-gray-600">
                          <b>Level:</b> {jobsData?.inferred_seniority_level}
                        </p>
                        <p className="text-sm text-gray-600">
                          <b>Job Type:</b> {jobsData?.job_type}
                        </p>
                        <p className="text-sm text-gray-600">
                          <b>Job Board:</b> {jobsData?.job_board}
                        </p>
                        <p className="text-sm text-orange-600">
                          <b>Remote:</b>{" "}
                          {jobsData?.is_remote === "true" ? "Yes" : "No"}
                        </p>
                        <p className="text-sm text-green-600 mb-5">
                          <b>Expired:</b>{" "}
                          {jobsData?.has_expired === "true" ? "Yes" : "No"}
                        </p>
                        <hr />
                        {jobsData?.html_job_description ? (
                          <div
                            className="text-gray-700 mt-5 mb-4"
                            dangerouslySetInnerHTML={{
                              __html:
                                jobsData?.html_job_description ??
                                jobsData?.job_description,
                            }}
                          />
                        ) : (
                          <div className="text-gray-700 mt-5 mb-4">
                            {jobsData?.job_description}
                          </div>
                        )}
                        <div className="flex flex-wrap gap-2">
                          {JSON.parse(jobsData?.inferred_skills).length > 0 &&
                            JSON.parse(jobsData?.inferred_skills).map(
                              (skill, index) => (
                                <span
                                  key={index}
                                  className="bg-blue-500 text-white px-3 py-1 rounded-full"
                                >
                                  {skill}
                                </span>
                              )
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </>
          ) : (
            <div className="w-full text-center bg-white">
              loading... Please wait
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
